export default "__VITE_ASSET__CipSngEK__"